// HeaderImage.tsx
import React from 'react';

const HeaderImage: React.FC = () => {
    return (
        <div className="logo"></div>
    );
};

export default HeaderImage;